module.exports = __webpack_public_path__ + "img/rubin_benefit_18_funeral.97a9206a.svg";